import { PluginApi, PluginKey } from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'
import { usePluginsStore } from '@/stores/plugins'

export class PluginService {
  static readonly pluginApi = new PluginApi(globalApiConfig)

  static async listEnabledPlugins(): Promise<PluginKey[]> {
    return (await PluginService.pluginApi.listEnabledPlugins()).data
  }

  static async syncPluginsWithBackend(): Promise<void> {
    const pluginsStore = usePluginsStore()

    try {
      const activePlugins = await PluginService.listEnabledPlugins()
      pluginsStore.setEnabledPlugins(activePlugins)
    } catch (error) {
      console.error(error)
      pluginsStore.setEnabledPlugins([])
    }
  }
}
